import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	// remove myChangesLabel when cleaning up plans-update-review-changes-to-unsaved-changes_sbz4w'
	myChangesLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.my-changes-label',
		defaultMessage: 'Issues changed by me',
		description:
			'The label for the button that is used to filter issues that were last updated by the user',
	},
	changedByMeLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.changed-by-me-label',
		defaultMessage: 'Changed by me',
		description:
			'The label for the button that is used to toggle changes made by the user in Plans',
	},
	myChangesTooltip: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.my-changes-tooltip',
		defaultMessage:
			'This option selects all the changes related to issues you’ve edited, including changes made by others. ',
		description:
			'The tip for the button that is used to filter issues that were last updated by the user',
	},
	// remove todaysChangesLabel when cleaning up plans-update-review-changes-to-unsaved-changes_sbz4w'
	todaysChangesLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.todays-changes-label',
		defaultMessage: 'Issues changed today',
		description:
			'The label for the button that is used to filter issues that were updated made today',
	},
	changedTodayLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.changed-today-label',
		defaultMessage: 'Changed today',
		description: 'The label for the button that is used to toggle items were updated today',
	},
	todaysChangesTooltip: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.todays-changes-tooltip',
		defaultMessage: 'This option selects all changes made to issues on {date}.',
		description:
			'The label for the button that is used to filter issues that were updated made today',
	},
	// remove inheritTimelineSelectionLabel when cleaning up plans-update-review-changes-to-unsaved-changes_sbz4w'
	inheritTimelineSelectionLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.inherit-timeline-selection-label',
		defaultMessage: 'Selected on the timeline',
		description:
			'The tooltip for the button that is used to filter changes that were selected on the timeline',
	},
	selectedOnTimelineLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.selected-on-timeline-label',
		defaultMessage: 'Selected on timeline',
		description:
			'The tooltip for the button that is used to toggle changes that were selected on the timeline',
	},
	inheritTimelineSelectionTooltip: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.inherit-timeline-selection-tooltip',
		defaultMessage:
			'This option only selects changes that apply to issues currently selected on your timeline.',
		description:
			'The tooltip for the button that is used to filter changes that were selected on the timeline',
	},
});

export default messages;
